//  标签搜索

import React from 'react';
import moment from 'moment';
import { Dropdown } from 'rsuite';

import { Select,Button,Empty,Spin,AutoComplete,Pagination } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import Cache from '../frame/Cache';
import Config from '../config/Config';

import WidgetAjax from '../widget/WidgetAjax';
import WidgetSelect from '../widget/WidgetSelect';
import WidgetDrawer from '../widget/WidgetDrawer';
import WidgetMessage from '../widget/WidgetMessage';
import WidgetTagTree from '../widget/WidgetTagTree';
import WidgetComponent from '../widget/WidgetComponent';
import WidgetInputView from '../widget/WidgetInputView';
import WidgetCondition from '../widget/WidgetCondition';
import WidgetPageTable from '../widget/WidgetPageTable';
import WidgetCheckbox from '../widget/WidgetCheckbox';

import AttributeSearch from './search/AttributeSearch';

import TitleLeft from "../img/BusinessChance/TitleLeft.svg";
import MapPOI from './MapPOI';
import EntityDetail from './EntityDetail';

import { useHistory } from 'react-router-dom'

import '../css/analysis.css';
import '../css/tag.css';
import '../css/RiskMonitor.css';
import '../css/scrm.table.css'
import '../css/table.css'
const { Option } = Select;

class NearbyEnt extends WidgetComponent 
{
    constructor( props ) 
    {
        super(props);

        let basePath = Config.getBasePath();

        let item, oldfilter = {}, conditions = {}, confirmConditions = {}, confirmValues=[], values = [], tagNodes = [];

        if (this.props.location !== undefined && this.props.location.state !== undefined) 
        {
            item = this.props.location.state.item;

            if (item !== undefined && item !== null) 
            {
                if (item.CONDITION !== undefined && item.CONDITION !== null && item.CONDITION.definitions !== undefined) 
                {
                    conditions = item.CONDITION.definitions.conditions !== undefined ? item.CONDITION.definitions.conditions : [];

                    values = item.CONDITION.definitions.values !== undefined ? item.CONDITION.definitions.values : [];

                    for(let value of values)
                    {
                        if( value!==undefined && value.length>0  )
                        {
                            for(let tagNode of value )
                            {
                                tagNodes.push(tagNode.value);
                            }
                        }
                        else
                        {
                            tagNodes.push(value.value);
                        }
                    }

                    confirmValues = [...values];
                    confirmConditions = {...conditions};
                }

                if (item.CONDITION !== undefined && item.CONDITION !== null && item.CONDITION.filters !== undefined) 
                {
                    oldfilter = item.CONDITION.filters;
                }
            }
        }


        this.onInputChange = this.onInputChange.bind(this);
        this.onFuzzySearch = this.onFuzzySearch.bind(this)

        this.readAttribute = this.readAttribute.bind(this);
        this.onReadAttribute = this.onReadAttribute.bind(this);

        this.attributeOnChange = this.attributeOnChange.bind(this);
        this.deleteAttributeCondition = this.deleteAttributeCondition.bind(this);

        this.readRanges = this.readRanges.bind(this);
        this.onReadRanges = this.onReadRanges.bind(this);

        this.readTagTree = this.readTagTree.bind(this);
        this.onReadTagTree = this.onReadTagTree.bind(this);

        this.onTagSelect = this.onTagSelect.bind(this);
        this.onTagChange = this.onTagChange.bind(this);
        this.deleteTagConditions = this.deleteTagConditions.bind(this);

        this.onkeyWordChange = this.onkeyWordChange.bind(this);
        this.readKeyWord = this.readKeyWord.bind(this);
        this.onReadKeyWord = this.onReadKeyWord.bind(this);

        this.onkeyWordFilterTypeSelect = this.onkeyWordFilterTypeSelect.bind(this);
        this.findFilterType = this.findFilterType.bind(this);

        this.addKeyword = this.addKeyword.bind(this);
        this.deleteKeyword = this.deleteKeyword.bind(this);
        this.deleteDrawerKeyword = this.deleteDrawerKeyword.bind(this);

        this.onCheckRangeChange = this.onCheckRangeChange.bind(this);
        this.deleteKeywordRange = this.deleteKeywordRange.bind(this);

        this.clear = this.clear.bind(this);
        this.search = this.search.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.pageTurning = this.pageTurning.bind(this);
        this.tableOnEvent = this.tableOnEvent.bind(this);
        this.transformOperations = this.transformOperations.bind(this);
        this.transformTEL = this.transformTEL.bind(this);

        this.buildFilter = this.buildFilter.bind(this);

        this.addMonitor = this.addMonitor.bind(this);
        this.addMonitorConfirm = this.addMonitorConfirm.bind(this);
        this.onAddMonitor = this.onAddMonitor.bind(this);

        this.removeMonitor = this.removeMonitor.bind(this);
        this.removeMonitorConfirm = this.removeMonitorConfirm.bind(this);
        this.onRemoveMonitor = this.onRemoveMonitor.bind(this);

        this.addCRM = this.addCRM.bind(this);
        this.addCRMConfirm = this.addCRMConfirm.bind(this);
        this.onAddCRM = this.onAddCRM.bind(this);

        this.removeCRM = this.removeCRM.bind(this);
        this.removeCRMConfirm = this.removeCRMConfirm.bind(this);
        this.onRemoveCRM = this.onRemoveCRM.bind(this);

        this.openFilterDrawer = this.openFilterDrawer.bind(this);
        this.filterDrawerConfirm = this.filterDrawerConfirm.bind(this);

        this.changeFilterType = this.changeFilterType.bind(this);

        this.tableOnCheck = this.tableOnCheck.bind(this)

        this.addMonitors = this.addMonitors.bind(this)

        this.removeTerm = this.removeTerm.bind(this)

        this.addCRMs = this.addCRMs.bind(this)
        this.deleteCRMConfirm = this.deleteCRMConfirm.bind(this)
        this.onDeleteCRM = this.onDeleteCRM.bind(this)

        this.changeMapConditionData = this.changeMapConditionData.bind(this);

        this.deleteMapPOICondition = this.deleteMapPOICondition.bind(this);

        this.export = this.export.bind(this);
        this.exportConfirm = this.exportConfirm.bind(this);
        this.onExport = this.onExport.bind(this);

        this.clearAttributeFilter = this.clearAttributeFilter.bind(this);

        this.clearTagSearch = this.clearTagSearch.bind(this);

        this.clearSearchIntellect = this.clearSearchIntellect.bind(this)

        this.state = {
            basePath: basePath,
            fuzzySearchData:[],
            fuzzyValue:'',
            isFuzzySearch:true,
            isFuzzySearchLoading:true,
            item: item,
            selectoptions:{
                cleanable : true,
            },
            fjloading:true,
            fjPage:1,

            groupData: [
                {label:'不限', value:'0'},
                {label:'正序', value:'1'},
                {label:'倒序', value:'2'}
            ],
            distanceData: [
                {label:'不限', value:'0'},
                {label:'距离最远', value:'1'},
                {label:'距离最近', value:'2'}
            ],
            group:undefined,
            distance:undefined,
            oldfilter: oldfilter,

            tagTreeOption: {
                inline: true,
                height: "100%"
            },
            tagTreeData: undefined,
            tagValues: values,
            tagNodes: tagNodes,
            confirmValues: confirmValues,

            mapConditions: {},
            confirmMapConditions :{},

            keyWord: undefined,
            keyWords: [],
            confirmKeyWords: [],
            keyWordRanges: [],
            searchKeyWords: [],
            keyWordFilterTypeData: [
                {
                    label: '包含所有',
                    value: '001',
                    type: "AND"
                },
                {
                    label: '包含任一',
                    value: '002',
                    type: "OR"
                }
            ],
            keyWordFilterType: "002",

            attributes: [],
            conditions: conditions,
            confirmConditions: confirmConditions,

            filterTypeOptions: {
                title: "条件类型",
                cleanable: false
            },
            filterTypeData: [
                { label: "所有", value: "ALL" },
                { label: "任一", value: "ANY" }
            ],
            filterTypeValue: "ALL",
            tabs: [
                { title: "条件筛选", key: 0 },
                { title: "标签查询", key: 1 },
                { title: "智能检索", key: 2 },
                { title: "地图查询", key: 3 }
            ],
            tabType: 0,

            messageOptions: {
                title: '添加监管'
            },
            drawerOptions: {
                size: 'lg',
                button: false,
            },
            filterDrawerOptions: {
                size: 'lg',
                button: true,
                confirmFunction: this.filterDrawerConfirm,
                backdrop: 'static'
            },

            tableOptions: {
                records: 10,
                rowKey: "ENTID",
                isAutoHeight: true,
                checkedKey: "ENTID",
                check: true,
            },
            loading : true,
            total : undefined,
            fjtotal : undefined,
            fjdata :[],
            fjndata :[],
            data :[],
            ndata :[],
            page : 1,
            checkData:[],
            checkDataLength:0,
            isBatch : false,
            detailData:undefined,
            entityData:undefined,
            columns: [
                [
                    { name: 'ENTID', title: 'ENTID', type: 'string', description: '主体ID', properties: { hidden: true } },
                ],
                [
                    { name: 'ENTID', title: 'ENTID', type: 'string', description: '主体ID', properties: { hidden: true } },
                    { name: 'MONITOR', title: 'MONITOR', type: 'string', description: '监控状态', properties: { hidden: true } },
                    { name: 'ENTNAME', type: 'string', description: '市场主体名称', properties: { hidden: false, click: "entityDetail" } },
                    { name: 'REGSTATE', type: 'string', description: '企业状态', properties: { hidden: false } },
                ],
                [
                    { name: 'TAGS', type: 'string', description: '主体标签', properties: { hidden: false, type: "label" } }
                ],
                [
                    { name: 'DOM', title: '经营地址', type: 'string', description: '经营地址', properties: { hidden: false } },
                    { name: 'INDUSTRYPHY', title: '行业类型', type: 'string', description: '行业类型', properties: { hidden: false } },
                    { name: 'REGCAP', title: '注册资本', type: 'string', description: '注册资本', properties: { hidden: false, unit:"万元"} },
                    { name: 'ESTDATE', title: '成立时间', type: 'string', description: '成立时间', properties: { hidden: false } }
                ],
                [
                    { name: 'TEL', title: '联系方式', type: 'string', description: '联系方式', properties: { hidden: false, transform: "transformTEL"} },
                ],
                [
                    {
                        name: 'operation', type: 'string', description: '操作', properties: {
                            operations: [
                                { name: '添加监控', click: "addMonitor" },
                                { name: '取消监控', click: "removeMonitor" },

                                { name: '添加CRM', click: "addCRM" },
                                { name: '取消CRM', click: "removeCRM" },

                                // { name: '添加种子企业', click: "addFavor"},
                                // { name: '取消种子企业', click: "removeFavor"},
                            ],
                            transform: "transformOperations"
                        }
                    }
                ]
            ],
            enter:"",
            keyWordRangeData:[],
            rangeData:[],
        };

        this.bindConsole(basePath);
    }

    componentDidMount() 
    {
        // 读取条件筛选属性
        this.readAttribute();

        // 读取查找范围
        this.readRanges();

        // 读取标签树
        this.readTagTree();

        // this.getList()
    }

    /** 消息提示框句柄 */
    setMessageRef = (ref) => {
        this.messageRef = ref;
    }

    /** 企业详情信息抽屉句柄 */
    drawerRef = (ref) => {
        this.drawerRef = ref;
    }

    /** 筛选条件抽屉句柄 */
    filterDrawerRef = (ref) => {
        this.filterDrawerRef = ref;
    }

    //  读取 条件查询条件
    readAttribute() 
    {
        const { basePath } = this.state;

        WidgetAjax.ajax({ url: basePath + '/search/attribute', params: {database_code:"BASE"}, callback: this.onReadAttribute });
    }

    onReadAttribute(result) 
    {
        if (result.status === 0) 
        {
            this.setState({ attributes: result.results });
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    //  读取智能检索 查询范围
    readRanges()
     {
        let { basePath } = this.state;

        WidgetAjax.ajax({ url: basePath + '/search/keyword_column', params: undefined, callback: this.onReadRanges });
    }

    onReadRanges(result) 
    {
        if (result.status === 0) 
        {
            let keyWordRanges = [];

            if (result.results !== undefined && result.results.length > 0) 
            {
                for (let item of result.results) 
                {
                    item["value"] = item.name;
                    item["code"] = item.name;
                    item["label"] = item.title;
                    keyWordRanges.push(item);
                }
            }

            this.setState({ keyWordRanges: keyWordRanges });
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    //  读取标签查询
    readTagTree() 
    {
        let { basePath } = this.state;

        WidgetAjax.ajax({ url: basePath + '/search/tag', params: {level:1, hierarchy:4}, callback: this.onReadTagTree });
    }

    onReadTagTree(result) 
    {
        const { page } = this.state;

        if (result.status === 0) 
        {
            this.setState({ tagTreeData: result.results });
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }

        this.search(page);
        this.searchList(page)
    }

    /**
     * 智能检索关键字输入框变化
     * @param {*} value 
     */
    onkeyWordChange(value) 
    {
        this.setState({ keyword: value ,enter:value.target.value});

        if (value !== undefined && value !== "")
        {
            let params = { keywords: [value.target.value], value};

            this.readKeyWord(params);
        }

    }

    // 读取关键词
    readKeyWord(params, keyword) 
    {
        let { basePath } = this.state;

        WidgetAjax.ajax({ url: basePath + '/search/keyword', params: params, callback: this.onReadKeyWord, backParam:keyword });
    }

    onReadKeyWord( result, backParam )
    {
        if( result.status===0 )
        {
            let resultData = result.results;

            if(resultData.length != 0)
            {
                resultData.forEach((item,index)=>{
                    item["isClick"] = false
                })
    
                resultData.unshift({association:backParam.keywords[0], isClick:false});
                
                this.setState({searchKeyWords:resultData});
            }
            else if(resultData.length === 0)
            {
                this.setState({searchKeyWords:[]});
            }
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 构建 filter
     */
    buildFilter() 
    {
        let { confirmValues, confirmConditions, confirmKeyWords, keyWordRangeData, attributes, keyWordFilterType, confirmMapConditions} = this.state, filters = {};

        const widgetCondition = new WidgetCondition();

        //条件筛选
        if (attributes !== undefined && attributes !== null && attributes.length > 0) 
        {
            for (let attribute of attributes) 
            {
                let expression, key = attribute.name;

                if (attribute.type === "DIMENSION") 
                {
                    key = attribute.content.code;
                }

                if (confirmConditions[key] !== undefined && confirmConditions[key] !== null) 
                {
                    switch (attribute.type) 
                    {
                        case "STRING":
                        {
                            if (attribute.index === "TEXT") 
                            {
                                expression = "${" + key + "} has '" + confirmConditions[key] + "'";
                            }
                            else 
                            {
                                expression = "${" + key + "} = '" + confirmConditions[key] + "'";
                            }

                            filters[key] = expression;
                            break;
                        }
                        case "DATE":
                        case "NUMBER":
                        case "INTEGER":
                        {
                            if (key === "ESTDATE") 
                            {
                                if (confirmConditions[key].start !== undefined && confirmConditions[key].start !== "") 
                                {
                                    let startValue = moment(moment(confirmConditions[key].start, 'YYYYMMDD')).format('YYYY-MM-DD');

                                    if (confirmConditions[key].end !== undefined && confirmConditions[key].end !== "") 
                                    {
                                        let endValue = moment(moment(confirmConditions[key].end, 'YYYYMMDD')).format('YYYY-MM-DD');

                                        expression = widgetCondition.createCondition(key, "range",
                                            { min: { code: key, operator: 'BE', value: startValue }, max: { code: key, operator: 'SE', value: endValue } });
                                    }
                                    else 
                                    {
                                        expression = '${' + key + '} >= ' + confirmConditions[key].start;
                                    }
                                }
                                else 
                                {
                                    if (confirmConditions[key].end !== undefined && confirmConditions[key].end !== "")
                                     {
                                        let endValue = moment(moment(confirmConditions[key].end, 'YYYYMMDD')).format('YYYY-MM-DD');

                                        expression = '${' + key + '} <= ' + endValue;
                                    }
                                    else 
                                    {
                                        expression = undefined;
                                    }
                                }
                            }
                            else 
                            {
                                if (confirmConditions[key].start !== undefined && confirmConditions[key].start !== "") 
                                {
                                    if (confirmConditions[key].end !== undefined && confirmConditions[key].end !== "") 
                                    {
                                        expression = widgetCondition.createCondition(key, "range",
                                            { min: { code: key, operator: 'BE', value: confirmConditions[key].start }, max: { code: key, operator: 'SE', value: confirmConditions[key].end } });
                                    }
                                    else 
                                    {
                                        expression = '${' + key + '} >= ' + confirmConditions[key].start;
                                    }
                                }
                                else 
                                {
                                    if (confirmConditions[key].end !== undefined && confirmConditions[key].end !== "")
                                    {
                                        expression = '${' + key + '} <= ' + confirmConditions[key].end;
                                    }
                                    else 
                                    {
                                        expression = undefined;
                                    }
                                }
                            }

                            filters[key] = expression;

                            break;
                        }
                        case "NOMINAL":
                        {
                            if (confirmConditions[key] !== undefined) 
                            {
                                let expression = widgetCondition.createCondition(key, "point", { code: key, operator: "E", value: confirmConditions[key] });

                                filters[key] = expression;
                            }
                            else {
                                filters[key] = undefined;
                            }
                            break;
                        }
                        case "DIMENSION":
                        {

                            key = attribute.content.code;

                            if (attribute.index === "SINGLE") 
                            {
                                if (confirmConditions[key] !== undefined && confirmConditions[key] !== null) 
                                {
                                    let item = confirmConditions[key];

                                    let code = attribute.content.code;

                                    expression = widgetCondition.createCondition(item.code, "point", { code: item.code, operator: "E", value: item.value });

                                    filters[code] = expression;

                                }
                            }
                            else 
                            {
                                if( confirmConditions[key]!==undefined && confirmConditions[key]!==null ) 
                                {
                                    let treeConditions = confirmConditions[key], params = [];

                                    for( let code in treeConditions) 
                                    {
                                        let set = [];
                                        for (let item of treeConditions[code]) 
                                        {
                                            set.push(item.value);
                                        }
                                        params.push({ code: code, operator: 'IN', set: set });
                                    }

                                    if( params.length > 0) 
                                    {
                                        expression = widgetCondition.createCondition(attribute.content.code, "composite", params);
                                    }

                                    filters[attribute.content.code.substring(0, 4)] = expression;

                                }
                            }
                        }
                    }
                }
            }
        }

        // 标签  filter
        for( let i in confirmValues ) 
        {
            let flag = true, key, expression;

            for (let j in confirmValues[i]) 
            {
                if (flag) 
                {
                    flag = !flag;
                    key = confirmValues[i][j].type;
                    expression = widgetCondition.createCondition(confirmValues[i][j].type, "point", { code: confirmValues[i][j].type, operator: "E", value: confirmValues[i][j].value });
                }
                else 
                {
                    expression += " OR " + widgetCondition.createCondition(confirmValues[i][j].type, "point", { code: confirmValues[i][j].type, operator: "E", value: confirmValues[i][j].value });
                }
            }

            filters[key] = expression;
        }

        // 关键词 filter
        let keyWordFilterTypeItem = this.findFilterType(keyWordFilterType);

        if (confirmKeyWords.length > 0 && keyWordRangeData.length > 0) 
        {
            if (keyWordFilterTypeItem.type === "OR") 
            {
                let keyFlag = true, expresFlag = true, key, expression;

                for (let i in keyWordRangeData) 
                {
                    if (keyFlag) 
                    {
                        keyFlag = !keyFlag;

                        key = keyWordRangeData[i].name;
                    }
                    else 
                    {
                        key += "|" + keyWordRangeData[i].name;
                    }

                    for (let j in confirmKeyWords) 
                    {
                        if (expresFlag) 
                        {
                            expresFlag = !expresFlag;

                            expression = "${" + keyWordRangeData[i].name + "} has '" + confirmKeyWords[j] + "'";
                        }
                        else 
                        {
                            expression += " OR " + "${" + keyWordRangeData[i].name + "} has '" + confirmKeyWords[j] + "'";
                        }
                    }
                }

                filters[key] = expression;

            }
            else if (keyWordFilterTypeItem.type === "AND") 
            {
                for (let i in keyWordRangeData) 
                {
                    let key = keyWordRangeData[i].name, expression, flag = true;

                    for (let j in confirmKeyWords) 
                    {
                        if (flag) 
                        {
                            flag = !flag;

                            expression = "${" + keyWordRangeData[i].name + "} has '" + confirmKeyWords[j] + "'";
                        }
                        else 
                        {
                            expression += " OR " + "${" + keyWordRangeData[i].name + "} has '" + confirmKeyWords[j] + "'";
                        }
                    }

                    filters[key] = expression;
                }
            }
        }


        // POI 条件
        if( confirmMapConditions!==undefined && confirmMapConditions!==null && Object.keys(confirmMapConditions).length>0 )
        {
            if( confirmMapConditions.hasOwnProperty("mapType"))
            {
                let expression;
                 
                switch( confirmMapConditions.mapType )
                {
                    case "range":
                    {
                        if( confirmMapConditions.circleCenter!==undefined && confirmMapConditions.circleRadius!==undefined )
                        {
                            let radius = confirmMapConditions.circleRadius.value/1000;
                            let center = confirmMapConditions.circleCenter;

                            expression = "${LOCATION} GDCIN ('["+center.coordinate[0]+","+center.coordinate[1]+"]', '"+radius+"km')";
                        }
                        break;
                    }
                    case "circle":
                    {
                        let radius = confirmMapConditions["radius"]/1000;
                        let center = confirmMapConditions["center"];

                        expression = "${LOCATION} GDCIN ('[" + center[0] + "," + center[1] + "]', '" + radius + "km')";

                        break;
                    }
                    case "rectangle":
                    {
                        let points = confirmMapConditions["points"];

                        let lnglats = "", isFirst = true;

                        for(let i=0; i<points.length; i++ )
                        {
                            let point = points[i];

                            if( i===0 || i===2 )
                            {
                                if( isFirst )
                                {
                                    lnglats = "'[" + point[0] + "," + point[1] +"]'";
                                    isFirst = false;
                                    
                                }
                                else
                                {
                                    lnglats += ", " + "'[" + point[0] + "," + point[1] +"]'";
                                }
                            }
                        }

                        expression = "${LOCATION} GBXIN (" + lnglats + ")";
                        break;
                    }
                    case "polygon":
                    {
                        let points = confirmMapConditions["points"];

                        let lnglats = "", isFirst = true;

                        for(let point of points )
                        {
                            if( isFirst )
                            {
                                lnglats = "'[" + point[0] + "," + point[1] +"]'";
                                isFirst = false;
                                
                            }
                            else
                            {
                                lnglats += ", " + "'[" + point[0] + "," + point[1] +"]'";
                            }
                        }

                        expression = "${LOCATION} GPYIN (" + lnglats + ")";

                        break;
                    }
                    default :
                        expression = undefined;
                        break;
                    
                }

                if( expression!==undefined )
                {
                    filters["LOCATION"] = expression;
                }

            }

            if( confirmMapConditions.hasOwnProperty("D150001"))
            {
                let treeConditions = confirmMapConditions["D150001"], params = [], expression;

                for( let code in treeConditions) 
                {
                    let set = [];

                    for (let item of treeConditions[code]) 
                    {
                        set.push(item.value);
                    }
                    params.push({ code: code, operator: 'IN', set: set });
                }

                if( params.length>0) 
                {
                    expression = widgetCondition.createCondition("D150001", "composite", params);

                    filters["D150001".substring(0, 4)] = expression;
                }
            }
        }

        return filters;
    }

    /**
     * 表格数据查询
     * @param {*} page 
     */
     search(page, btn) 
     {
         let { tableOptions, basePath, oldfilter, filterTypeValue, group, distance,fuzzyValue } = this.state, filterType = "ALL";
         if ( btn ) 
         {
             this.setState({ flags: true});
         }
 
         let filters = this.buildFilter();
 
         if (page === undefined || page === null || page === "") 
         {
             page = 1;
         }
 
         if( filterTypeValue==="ANY" ) 
         {
             filterType = "ANY";
         }
 
         let params = {
             schema: "T001001",
             page: page,
             records: tableOptions.records,
             filters: {},
             filter_mode: filterType
         }
         if(fuzzyValue){
            params.filters = {"ENTNAME":"${ENTNAME} has '"+fuzzyValue+"'"}
         }  
         // if(group) params['group'] = group;
         // if(distance) params['distance'] = distance;
 
         WidgetAjax.ajax({ url: basePath + '/report/data', params: params, callback: this.onSearch });
 
         this.setState({ loading: true, page: page });
     }

    /**
     * 表格数据查询
     * @param {*} page 
     */
    searchList(page=1,orderValue = 'asc') 
    {
        let { basePath,fuzzyValue } = this.state;
        let user_info = JSON.parse(sessionStorage.getItem('_user_info_'))

        console.log(orderValue)
        let params = {
            "schema":"T001005",
            "filters":{"LOCATION":"${LOCATION} GDCIN ('["+user_info.extensions.LONLAT+"]', '1.5km')"},
            "sorts":{
                "LOCATION":{"type":"GD","point":"["+user_info.extensions.LONLAT+"]","unit":"km","order":""+orderValue+""}
            },

            // "filters":{
                // "LOCATION":"${LOCATION} GDCIN ('[121.4882863,31.23689208]', '1km')",
                // "ENTNAME":"${ENTNAME} has '大井头'"
                // "LOCATION":"${LOCATION} GDCIN ('["+user_info.extensions.LONLAT+"]', '1km')",
                // "ENTNAME":"${ENTNAME} has '"+fuzzyValue+"'"
            // },
            "page":page,
            "records":25
        }
        if(fuzzyValue!=''){
            params["filters"]['ENTNAME'] = "${ENTNAME} has '"+fuzzyValue+"'"
        }
        
        // if(group) params['group'] = group;
        // if(distance) params['distance'] = distance;

        this.setState({ fjloading: true });
        WidgetAjax.ajax({ url: basePath + '/report/data', params: params, callback:(result)=>{
            if (result.status === 0) 
            {
                this.setState({ fjPage:page, fjdata: result.results,fjndata:result.results,fjtotal: result.total, fjloading: false });
            }
            else if (result.status === 10) 
            {
                Cache.logout(this.props)
            }
            else
            {
                this.setState({fjPage:page,fjdata:[],fjndata:[], fjtotal:0, fjloading:false});
            }
        }});

    }


    onSearch(result, params) 
    {
        console.log(result)
        if (result.status === 0) 
        {
            this.setState({ data: result.results,ndata:result.results,total: result.total, loading: false });
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props)
        }
        else
        {
            this.setState({data:[],ndata:[], total:0, loading:false});
        }
    }

    /**
     * 表格翻页
     * @param {*}} page 
     */
    pageTurning(page)
     {
        this.search(page);
    }

    /**
     * 表格事件
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     * @returns 
     */
    tableOnEvent(type, data, value, event) 
    {
        switch (type) 
        {
            case "transformTEL":
            {
                data = JSON.parse(data);

                return this.transformTEL(data, value);
            }
            case "transformOperations":
            {
                return this.transformOperations(data, value);
            }
            case "entityDetail":
            {

                data = JSON.parse(data);

                this.setState({ detailData: data });

                this.drawerRef.open();

                break;
            }
            case "addMonitor":
            {
                data = JSON.parse(data);

                this.addMonitor(data);

                break;
            }
            case "removeMonitor":
            {
                data = JSON.parse(data);

                this.removeMonitor(data);

                break;
            }
            case "addFavor":
            {
                data = JSON.parse(data);

                this.addFavor(data);

                break;
            }
            case "removeFavor":
            {
                data = JSON.parse(data);

                this.removeFavor(data);

                break;
            }
            case "addCRM":
            {
                data = JSON.parse(data);
                this.addCRM(data);
                break;
            }
            case "removeCRM":
            {
                data = JSON.parse(data);
                this.removeCRM(data);
                break;
            }
            default:
                break;
        }
    }

    /**
     * 表格数据转换
     * @param {*} data 
     * @param {*} content 
     * @returns 
     */
    transformOperations(data, content) 
    {
        if (content.props !== undefined && content.props.children !== undefined) 
        {
            for (let i = 0; i < content.props.children.length; i++) 
            {
                let child = content.props.children[i];

                if (child.props.className === "addMonitor") 
                {
                    if (data.MONITOR === true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "removeMonitor") 
                {
                    if (data.MONITOR !== true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "addCRM") 
                {
                    if (data.CRM === true) {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "removeCRM") 
                {
                    if (data.CRM !== true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "addFavor")
                {
                    if (data.FAVOR === true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "removeFavor") 
                {
                    if (data.FAVOR !== true) {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
            }
        }

        return content;
    }

    /**
     * 联系方式转换
     * @param {*} data 
     * @param {*} content 
     * @returns 
     */
    transformTEL( data, content )
    {
        if( data.TEL!==undefined && data.TEL!==null && data.TEL.length>0 )
        {
            let value = "", isFirst = true;
            for( let item of data.TEL )
            {
                if( isFirst )
                {
                    value = `<label className='tel'>`+item.tel+`</label>`;
                    isFirst = false;
                }
                else
                {
                    value += `<label className='tel'>`+item.tel+`</label>`;
                }
            }

            return value;
        }
    }

    /**
     * 添加监管
     * @param {*} data 
     */
    addMonitor(d) {

        let data = JSON.parse(d)

        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.addMonitorConfirm;

        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 添加到监管对象中吗?`;

        messageOptions["title"] = "添加监管";

        this.state['messageOptions'] = messageOptions;

        this.state['entityData'] = data;

        this.messageRef.open();

    }

    addMonitors() 
    {

        let { messageOptions, checkData } = this.state, ENTNAMEs = "", isFirst = true;

        messageOptions["isMessage"] = false;

        if (!checkData.length) 
        {
            messageOptions["isMessage"] = true;

            messageOptions["message"] = `请选择需要添加监控的企业`;

            messageOptions["title"] = "添加监控企业";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else 
        {
            for (let item of checkData) 
            {
                if (isFirst === true) {
                    ENTNAMEs = `'` + item.ENTNAME + `'`

                    isFirst = false;
                }
                else {
                    ENTNAMEs += `, '` + item.ENTNAME + `'`
                }
            }

            messageOptions["message"] = `确定要把 '` + ENTNAMEs + `' 加入监控对象吗?`;

            messageOptions['confirmFunction'] = this.addMonitorConfirm;

            messageOptions["title"] = "添加监控";

            this.state['isBatch'] = true;
            this.state['entityData'] = undefined;
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
    }

    addMonitorConfirm() 
    {
        const { basePath, entityData, isBatch, checkData } = this.state;
        let params = {};

        if (isBatch === true) 
        {
            let ENTIDs = [];

            for (let item of checkData) 
            {
                ENTIDs.push(item.ENTID);
            }

            params["ENTIDs"] = ENTIDs;
        }
        else 
        {
            params["ENTID"] = entityData.ENTID;
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/add_entity', params: params, callback: this.onAddMonitor, backParam: { data: entityData } });
    }

    onAddMonitor(result, params, backParam) 
    {
        if (result.status === 0) 
        {
            let { messageOptions, isBatch, checkData } = this.state;

            messageOptions["isMessage"] = true;

            if (isBatch === true) 
            {
                let ENTNAMEs = "", isFirst = true;

                for (let item of checkData) 
                {
                    if (isFirst === true) 
                    {
                        ENTNAMEs = `'` + item.ENTNAME + `'`

                        isFirst = false;
                    }
                    else 
                    {
                        ENTNAMEs += `, '` + item.ENTNAME + `'`
                    }
                }

                if (result.result === checkData.length) 
                {
                    messageOptions["message"] = ENTNAMEs + `' 全部成功加入监控对象中！`;
                    this.search(1);
                    this.searchList(1);
                }
                else 
                {
                    messageOptions["message"] = ENTNAMEs + `' 中有 ` + result.result + ` 条成功添加监控, 有 ` + (checkData.length - result.result) + ` 条失败!`;
                    this.search(1);
                    this.searchList(1);
                }
            }
            else 
            {
                messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添加进监控对象中！`;
                this.search(1);
                this.searchList(1);
            }

            messageOptions["title"] = "添加监控";

            this.state['entityData'] = undefined;
            this.state['checkData'] = [];
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();

            // setTimeout(() => { this.search() }, 1300)
        }
        else if (result.status === 10)
        {
            Cache.logout(this.props);
        }

    }

    /**
     * 取消监管
     * @param {*} data 
     */
    removeMonitor(d) 
    {

        let data = JSON.parse(d)

        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.removeMonitorConfirm;

        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 从监管对象中移除吗?`;

        messageOptions["title"] = "取消监管";

        this.state['messageOptions'] = messageOptions;

        this.state['entityData'] = data;

        this.messageRef.open();
    }


    removeMonitorConfirm() 
    {
        const { basePath, entityData, isBatch, checkData } = this.state;

        let params = {};

        if (isBatch === true) 
        {
            let ENTIDs = [];

            for (let item of checkData) 
            {
                ENTIDs.push(item.ENTID);
            }

            params["ENTIDs"] = ENTIDs;
        }
        else 
        {
            params["ENTID"] = entityData.ENTID;
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/remove_entity', params: params, callback: this.onRemoveMonitor, backParam: { data: entityData } });
    }


    onRemoveMonitor(result, params, backParam) 
    {
        if (result.status === 0) 
        {
            let { messageOptions, isBatch, checkData } = this.state;

            messageOptions["isMessage"] = true;

            if (isBatch === true) 
            {
                let ENTNAMEs = "", isFirst = true;

                for (let item of checkData) 
                {
                    if (isFirst === true) 
                    {
                        ENTNAMEs = `'` + item.ENTNAME + `'`

                        isFirst = false;
                    }
                    else 
                    {
                        ENTNAMEs += `, '` + item.ENTNAME + `'`
                    }
                }

                if (result.result === checkData.length) 
                {
                    messageOptions["message"] = ENTNAMEs + `' 全部成功取消监控！`;
                }
                else 
                {
                    messageOptions["message"] = ENTNAMEs + `' 中有 ` + result.result + ` 条成功取消监控, 有 ` + (checkData.length - result.result) + ` 条失败!`;
                }
            }
            else 
            {
                messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添从监管对象中移除！`;
            }

            messageOptions["title"] = "取消监管";

            this.state['entityData'] = undefined;
            this.state['checkData'] = [];
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();

            setTimeout(() => { 
                this.search(1)
                this.searchList(1);
            }, 1500)
        }
        else if (result.status === 10)
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 添加 CRM
     * @param {*} data 
     */
    addCRM(d) 
    {
        let data = JSON.parse(d)
        let { messageOptions } = this.state;
        messageOptions["isMessage"] = false;
        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 添加至CRM中吗?`;
        messageOptions['confirmFunction'] = this.addCRMConfirm;
        messageOptions["title"] = "添加CRM";
        messageOptions["entData"] = data

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }

    /**
     * 将选中的企业添加进CRM
     */
    addCRMs() 
    {
        let { checkData, messageOptions } = this.state

        if (!checkData.length) 
        {
            messageOptions["isMessage"] = true;
            messageOptions["message"] = `请选择要添加CRM的企业`;
            messageOptions["title"] = "添加CRM";
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else 
        {
            let Objs, isFirst = true;

            for (let item of checkData) 
            {
                if (isFirst) 
                {
                    Objs = item.ENTNAME;

                    isFirst = false;
                }
                else 
                {
                    Objs += ", " + item.ENTNAME;
                }
            }

            messageOptions["isMessage"] = false;
            messageOptions['confirmFunction'] = this.addCRMConfirm;
            messageOptions['message'] = `您确定要将 ${Objs} 加入CRM吗?`;
            this.state['messageOptions'] = messageOptions;
            this.state["isBatch"] = true

            this.messageRef.open();
        }
    }

    addCRMConfirm() 
    {
        let { messageOptions, basePath, isBatch, checkData } = this.state, params;
        if (isBatch === true) 
        {
            let ENTIDs = [];

            for (let item of checkData) 
            {
                ENTIDs.push(item.ENTID);
            }

            params = {
                "ENTIDs": ENTIDs
            }

            WidgetAjax.ajax({ url: basePath + '/follow/add_entity', params: params, callback: this.onAddCRM, backParam: { checkData } });
        }
        else 
        {
            let data = messageOptions["entData"];

            params = {
                "ENTID": data["ENTID"]
            };

            WidgetAjax.ajax({ url: basePath + '/follow/add_entity', params: params, callback: this.onAddCRM, backParam: { Name: data.ENTNAME } });
        }
    }

    onAddCRM(result, params, backParam)
    {
        if (result.status === 0) 
        {
            if (backParam.checkData) 
            {
                let { messageOptions } = this.state, isFirst = true, addCRMName = '';

                messageOptions["isMessage"] = true;

                for (let item in backParam.checkData) 
                {
                    if (isFirst) 
                    {
                        addCRMName = backParam.checkData[item].ENTNAME;
                        isFirst = false
                    }
                    else 
                    {
                        addCRMName += ", " + backParam.checkData[item].ENTNAME;
                    }
                }

                let defeatedAdd = backParam.checkData.length - result.result

                messageOptions["message"] = `已将 ${addCRMName} 添加至CRM!  有 ${result.result} 条添加成功， 有 ${defeatedAdd} 条已存在CRM中或添加失败！`;
                messageOptions["title"] = "添加成功";

                this.state['messageOptions'] = messageOptions;
            }
            else 
            {
                let { messageOptions } = this.state;

                messageOptions["isMessage"] = true;
                messageOptions["message"] = `已将 ${backParam.Name} 添加至CRM!`;
                messageOptions["title"] = "添加成功";

                this.state['messageOptions'] = messageOptions;
            }

            this.messageRef.open();
        }
        else if (result === 10) 
        {
            Cache.logout(this.props);
        }
        else if (result.status === -1) 
        {
            let { messageOptions } = this.state;

            messageOptions["isMessage"] = true;
            messageOptions["message"] = `发生错误，添加失败！`;
            messageOptions["title"] = "错误";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }

        this.state["isBatch"] = false
    }


    /**
     * 取消 CRM
     * @param {*} data 
     */
    removeCRM( data )
    {
        let { messageOptions, checkData } = this.state;

        messageOptions["isMessage"] = false ;
        messageOptions["message"] = `确定要将 '` + data.ENTNAME +`' 从CRM中移除吗?` ;
        messageOptions['confirmFunction'] = this.removeCRMConfirm;
        messageOptions["title"] = "移出CRM" ;
        messageOptions["entData"] = data

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }

    removeCRMConfirm()
    {
        let { messageOptions, basePath } = this.state, 
        data = messageOptions["entData"],
        params = {
            "ENTID":data.ENTID
        };

        WidgetAjax.ajax({url:basePath + '/follow/remove_entity', params:params, callback:this.onRemoveCRM, backParam:{Name:data.ENTNAME}});
    }

    onRemoveCRM( result, params, backParam )
    {
        if( result.status === 0 )
        {
            let { messageOptions } = this.state;
            messageOptions["isMessage"] = true ;
            messageOptions["message"] = `已将 ${backParam.Name} 从CRM中移除!` ;
            messageOptions["title"] = "移除成功" ;
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
        else if( result.status === -1 )
        {
            let { messageOptions } = this.state;

            messageOptions["isMessage"] = true;
            messageOptions["message"] = `发生错误，添加失败！` ;
            messageOptions["title"] = "错误" ;
            this.state['messageOptions'] = messageOptions;
            this.messageRef.open();
        }
    }

    /**
     * 打开筛选条件抽屉
     */
    openFilterDrawer() {
        this.filterDrawerRef.open();
    }

    /**
     * 筛选条件抽屉确定回调函数
     */
    filterDrawerConfirm()
    {
        let { conditions, tagValues, keyWords, mapConditions, keyWordRangeData, messageOptions  } = this.state;

        if( tagValues===undefined || tagValues===null )
        {
            tagValues = [];
        }

        if( keyWords===undefined || keyWords===null )
        {
            keyWords = [];
        }

        if( conditions===undefined || conditions===null )
        {
            conditions = {};
        }

        if( mapConditions===undefined || mapConditions===null )
        {
            mapConditions = {};
        }

        messageOptions["title"] = "智能检索";
        messageOptions["isMessage"] = true;

        if(!(keyWords.length === 0 && keyWordRangeData.length === 0))
        {
            if(keyWords.length === 0)
            {
                messageOptions["message"] = "联想关键词 至少选择一个！";
                this.messageRef.open();
                this.setState({
                    tabType:2
                })
                return null;
            }

            if(keyWordRangeData.length === 0)
            {
                messageOptions["message"] = "查找范围 至少勾选一个！";
                this.messageRef.open();
                this.setState({
                    tabType:2
                })
                return null;
            }
            if(keyWords.length >= 1 && keyWordRangeData.length >= 1)
            {
                let confirmMapConditions = {...mapConditions};
                let confirmConditions = {...conditions};
                let confirmValues = [...tagValues];
                let confirmKeyWords = [...keyWords];
        
                this.setState({ 
                    confirmConditions : confirmConditions, 
                    confirmKeyWords:confirmKeyWords, 
                    confirmValues:confirmValues, 
                    confirmMapConditions:confirmMapConditions,
                    rangeData:keyWordRangeData
                });
                this.filterDrawerRef.close();
            }
        }
        else
        {
            let confirmMapConditions = {...mapConditions};
            let confirmConditions = {...conditions};
            let confirmValues = [...tagValues];
            let confirmKeyWords = [...keyWords];
    
            this.setState({ 
                confirmConditions : confirmConditions, 
                confirmKeyWords:confirmKeyWords, 
                confirmValues:confirmValues, 
                confirmMapConditions:confirmMapConditions,
                rangeData:keyWordRangeData
            });
            this.filterDrawerRef.close();
        }
    }

    /**
     * 整体条件筛选类型变化回调函数
     * @param {*} value 
     */
    async changeFilterType(value,type) 
    {
        switch(type)
        {
            case 'e':
                this.setState({ filterTypeValue: value });
                break;
            case 'group':
                await this.setState({ group: value });
                // this.search()
                break;
            case 'distance':
                await this.setState({ distance: value});
                // this.search()
                break;
            default:
                break;
        }
       
    }

    
    /**
     * 筛选项条件变化回调函数
     */
    attributeOnChange(conditions) 
    {
        this.setState({ conditions: conditions });
    }

    /**
     * 删除属性筛选条件
     * @param {*} event 
     * @param {*} attribute 
     */
    deleteAttributeCondition(event, attribute) 
    {
        event.stopPropagation();

        let { conditions, confirmConditions } = this.state;

        switch (attribute.type) 
        {
            case "DIMENSION":
            {
                let code = attribute.content.code;

                delete conditions[code];
                delete confirmConditions[code];
                break;
            }
            default:
            {
                delete conditions[attribute.name];
                delete confirmConditions[attribute.name];
                break;
            }
        }

        this.setState({ conditions: conditions, confirmConditions: confirmConditions });
    }

    /**
     * 标签选择回调函数
     * @param {*} values 
     * @param {*} item 
     * @param {*} event 
     */
    onTagSelect(values, item, event) {

    }

    /**
     * 标签变化回调函数
     * @param {*} values 
     * @param {*} nodes 
     * @param {*} event 
     */
    onTagChange(values, tagNodes, event) {
        this.setState({ tagValues: values, tagNodes: tagNodes });
    }

    /**
     * 标签条件删除
     * @param {*} item 
     */
    deleteTagConditions(tag, e) 
    {
        let { tagValues, confirmValues, tagNodes } = this.state;

        e.stopPropagation();

        tagNodes.splice(tagNodes.findIndex(item => item === tag.value), 1);

        for (let tags of tagValues) 
        {
            let isDelete = false;

            for (let i = 0; i < tags.length; i++) 
            {
                if (tags[i].value === tag.value) 
                {
                    tags.splice(i, 1);
                    isDelete = true;

                    break;
                }
            }

            if (isDelete) 
            {
                break;
            }
        }

        for (let tags of confirmValues) 
        {
            let isDelete = false;

            for (let i = 0; i < tags.length; i++)
            {
                if (tags[i].value === tag.value) 
                {
                    tags.splice(i, 1);

                    isDelete = true;

                    break;
                }
            }

            if (isDelete) 
            {
                break;
            }
        }

        this.setState({ confirmValues: confirmValues, tagValues: tagValues, tagNodes: tagNodes });
    }

    /**
     * 删除地图标签
     */
    deleteMapPOICondition( type, e)
    {
        let { mapConditions, confirmMapConditions} = this.state;
        
        e.stopPropagation()

        switch( type )
        {
            case "range" :
            {
                delete mapConditions["circleCenter"];
                delete mapConditions["circleRadius"];

                delete confirmMapConditions["circleCenter"];
                delete confirmMapConditions["circleRadius"];

                break;
            }
            case "circle" :
            {
                delete mapConditions["center"];
                delete mapConditions["radius"];

                delete confirmMapConditions["center"];
                delete confirmMapConditions["radius"];

                break;
            }
            case "rectangle" :
            {
                delete mapConditions["points"];

                delete confirmMapConditions["points"];

                break;
            }
            case "polygon" :
            {
                delete mapConditions["points"];

                delete confirmMapConditions["points"];
                break;
            }
            case "D150001" : 
            {
                delete mapConditions["D150001"];

                delete confirmMapConditions["D150001"];
                break;
            }
        }

        this.setState({mapConditions:mapConditions, confirmMapConditions:confirmMapConditions});
    }

    /**
     * 选中关键字
     * @param {*} value 
     */
    addKeyword(value) 
    {
        let { searchKeyWords, keyWords } = this.state;

        searchKeyWords[searchKeyWords.indexOf(value)].isClick = true

        if (!keyWords.includes(value.association))
        { 
            keyWords.push(value.association)
        }
        else
        {
            this.deleteDrawerKeyword(value.association)
            searchKeyWords[searchKeyWords.indexOf(value)].isClick = false
        }

        this.setState({ keyWords: keyWords, searchKeyWords });
    }

    /**
     * 删除关键字
     */
    deleteDrawerKeyword(item) 
    {
        let { keyWords } = this.state;

        for (let i = 0; i < keyWords.length; i++)
        {
            if (item === keyWords[i]) 
            {
                keyWords.splice(i, 1);
            }
        }

        this.setState({ keyWords: keyWords });
    }

    /**
     * 删除关键字
     * @param {*} item 
     */
    deleteKeyword(item) 
    {
        let { keyWords, confirmKeyWords, searchKeyWords } = this.state;

        for (let i = 0; i < keyWords.length; i++) 
        {
            if (item === keyWords[i]) 
            {
                keyWords.splice(i, 1);
            }
        }

        for (let i = 0; i < confirmKeyWords.length; i++) 
        {
            if (item === confirmKeyWords[i]) 
            {
                confirmKeyWords.splice(i, 1);
            }
        }

        for(let i = 0; i < searchKeyWords.length;i++)
        {
            if(searchKeyWords[i].association === item)
            {
                searchKeyWords[i].isClick = false
            }
        }
        this.setState({ keyWords: keyWords, confirmKeyWords: confirmKeyWords, searchKeyWords });
    }



    /**
     * 关键字筛选类型选择回调
     * @param {*} value 
     * @param {*} item 
     * @param {*} event 
     */
    onkeyWordFilterTypeSelect(value, item, event) 
    {
        this.setState({ keyWordFilterType: value });
    }

    /**
     * 查找关键字筛选条件类型
     * @param {*} value 
     * @returns 
     */
    findFilterType(value) 
    {
        const { keyWordFilterType, keyWordFilterTypeData } = this.state;

        if (value === undefined) value = keyWordFilterType;

        for (let item of keyWordFilterTypeData) {
            if (item.value === value)

                return item;
        }
    }

    /**
     * 关键字查询范围选择
     * @param {*} value 
     * @param {*} data 
     */
    onCheckRangeChange(value, data) 
    {
        this.setState({ keyWordRangeData: data });
    }

    /**
     * 关键字查询范围删除
     * @param {*} item 
     */
    deleteKeywordRange(item, e) 
    {
        let { keyWordRangeData } = this.state;

        e.stopPropagation();

        for (let i = 0; i < keyWordRangeData.length; i++) 
        {
            if (keyWordRangeData[i].code === item.code) 
            {
                keyWordRangeData.splice(i, 1);
            }
        }
        this.setState({ keyWordRangeData: keyWordRangeData });
    }

    /**
     * 取消CRM
     */
    deleteCRMConfirm() 
    {
        const { checkData, basePath } = this.state;

        let OBJIDs = [];

        for (let item of checkData) {
            OBJIDs.push(item.ENTID);
        }

        let params = {
            "ids": OBJIDs
        }
        WidgetAjax.ajax({ url: basePath + '/follow/remove_entity', params: params, callback: this.onDeleteCRM });
    }

    onDeleteCRM(result, params) 
    {
        let { messageOptions } = this.state

        messageOptions["isMessage"] = true;

        if (result.status === 0) 
        {
            messageOptions['message'] = '删除成功'
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
        else 
        {
            messageOptions['message'] = '删除失败'
        }
        this.messageRef.open();
    }


    /**
     * 表格单击事件
     */
    tableOnCheck(data) 
    {
        this.state["checkData"] = data;

        this.setState({ checkDataLength: this.state.checkData.length })
    }

    removeTerm(item, e) 
    {
        let { confirmKeyWords } = this.state;

        e.stopPropagation()

        for (let i = 0; i <= confirmKeyWords.length; i++) 
        {
            if (confirmKeyWords[i] === item) 
            {
                confirmKeyWords.splice(i, 1)
            }
        }
        this.setState({ confirmKeyWords: confirmKeyWords })
    }

    /**
     * 地图搜索条件回调函数
     * @param {*} mapConditions 
     */
    changeMapConditionData( mapConditions ) 
    {
        this.setState({ mapConditions:mapConditions });
    }

     /**
     * 导出按钮
     */
    export( )
    {
        let { messageOptions, checkData}=this.state;

        messageOptions["isMessage"] = false ;
       
        // if( type==="1" )
        // {
        //     if( checkData===undefined || checkData===null || checkData.length===0 )
        //     {
        //         messageOptions["isMessage"] = true ;

        //         messageOptions["message"] = `没有选中的记录?` ;
        
        //         messageOptions["title"] = "导出";

        //     }
        //     else
        //     {
        //         messageOptions["message"] = `确定要导出当前选中的记录吗?` ;
        //     }
        // }
        // else if(  type==="2" )
        // {
        //     messageOptions["message"] = `确定要导出符合当前条件的前20条记录吗?` ;
        // }
        // else if(  type==="3" )
        // {
        //     messageOptions["message"] = `确定要导出符合当前条件的前50条记录吗?` ;
        // }
        // else if(  type==="4" )
        // {
        //     messageOptions["message"] = `确定要导出符合当前条件的前100条记录吗?` ;
        // }
        // else
        // {
        //     messageOptions["message"] = `确定要导出符合当前条件的全部记录吗?` ;
        // }

        if( checkData!==undefined && checkData!==null && checkData.length>0 )
        {
            messageOptions["message"] = `确定要导出当前选中的 ` + checkData.length + ` 记录吗?`;
        }
        else
        {
            messageOptions["message"] = `确定要导出符合条件的全部记录吗?`;
        }

        messageOptions['confirmFunction'] = this.exportConfirm;
    
        messageOptions["title"] = "导出确认" ;
       
        this.state['messageOptions'] = messageOptions;

        this.messageRef.open(); 
    }

    exportConfirm()
    {
        const { basePath, checkData, filterTypeValue} = this.state;

        let filters = {}, filterType = "ALL" ;

        if( checkData!==undefined && checkData.length>0 )
        {
            let isFirst = true, content = "";
            for(let item of checkData )
            {
                if( isFirst )
                {
                    content = "'"+item.ENTID+"'";
                    isFirst = false;
                }
                else
                {
                    content += ",'" + item.ENTID +"'";
                }

            }

            filters["ENTID"] = "${ENTID} IN ("+content+")";
        }
        else
        {
            filters = this.buildFilter();

            if ( filterTypeValue==="ANY" ) 
            {
                filterType = "ANY";
            }
        }


        let params = {
            schema: "T001001",
            filters: filters,
            filterType: filterType
        }

        WidgetAjax.ajax({url:basePath + '/report/excel', params:params, callback:this.onExport}); 
    }

    onExport( result, params )
    {        
        const { basePath, messageOptions } = this.state;

        let fileName = "export.xlsx";

        if( result.status===0 )
        {
            let token = result.token;

            let url = basePath + "/report/download";

            WidgetAjax.exportFile({ url:url, params:{token:token, fileName:fileName} });

        }
        else if( result.status===10 )
        {
            Cache.logout(this.props.parentProps);
        }
        else
        {
            messageOptions["isMessage"] = true ;

            messageOptions["message"] = '数据导出失败！' ;

            messageOptions["title"] = "数据导出" ;

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
    }

    
    /**
     * 清空页面条件
     */
     clear()
     {
         this.setState({ tagValues:[], confirmValues:[], tagNodes:[],
              keyWords:[], confirmKeyWords:[], keyWordFilterType:"002", 
             conditions:[], confirmConditions:{}, filterTypeValue:"ALL",mapConditions:{}, confirmMapConditions:{}
             ,searchKeyWords:[],keyword:undefined,keyWordRangeData:[]
         });
     }

    /**
     * 条件筛选
     */
    clearAttributeFilter()
    {
        this.setState({
            confirmConditions:[],
            conditions:[]
        })
    }
    /**
     * 标签查询
     */
    clearTagSearch()
    {
        this.setState({ tagValues:[], tagNodes:[] })
    }

    /**
     * 智能检索
     */
     clearSearchIntellect()
    {
        // keyWordFilterTypeData:[]
        this.setState( {keyWords:[], confirmKeyWords:[],searchKeyWords:[],keyword:undefined,keyWordRangeData:[]})
    }

    
    WidgetTagTreeRef = (ref)=>{
        this.WidgetTagTreeRef = ref
    }

   
    onFuzzySearch( value )
    {
        let { basePath } = this.state;

        let params = {
            ENTNAME:value
        }

        WidgetAjax.ajax({url:basePath + '/entity/vague_search', params:params, callback:(result)=>{
            if (result.status === 0) 
            {

                this.setState({fuzzySearchData:result.results, isFuzzySearchLoading:true});
            }
            else if (result.status === 10) 
            {
                Cache.logout(this.props);
            }
        }}); 
    }

      /**
     * input 框监控
     * @param {*} key 
     */
    onInputChange( value )
    {
        let { conditions,timeout } = this.state, filters;
        let { attributes } = this.props;

        // if(key === "ENTNAME"){
            if( value.length > 0 )
            {
                clearTimeout(timeout)
                this.setState({
                    isFuzzySearch:true,
                    isFuzzySearchLoading:false,
                }, ()=>{
                    timeout = setTimeout(()=>{
                        this.onFuzzySearch( value )
                    }, 1000)
                    this.setState({timeout})
                })
                
            }
            else 
            {
                clearTimeout(timeout)
                this.setState({
                    isFuzzySearch:false
                })
            }
        // }
    }

    fuzzyOnChange (value) {
        this.setState({
            fuzzyValue:value?value:''
        },()=>{
            this.search(1)
        })
    }
    
    fuzzyOnSearch (value){
        this.onInputChange(value)
        // if(value==''){
        this.setState({
            fuzzyValue:value?value:''
        })
        // }
        console.log('search:', value);
    }

    // getList(){
    //     let { basePath,fuzzyValue } = this.state;
    //     let user_info = JSON.parse(sessionStorage.getItem('_user_info_'))
    //     let params = {
    //         "schema":"T001005",
    //         "filters":{
    //             "LOCATION":"${LOCATION} GDCIN ('["+user_info.extensions.LONLAT+"]', '1km')",
    //             "ENTNAME":"${ENTNAME} has '"+fuzzyValue+"'"
    //         },
    //         "page":1,
    //         "records":25
    //     }
    //     WidgetAjax.ajax({url:basePath + '/report/data', params:JSON.stringify(params), callback:(result)=>{
    //        console.log(result)
    //     }}); 
    // }
    exportSelect(e){
        let {fjdata,fjndata,fjPage} = this.state
        let newData = JSON.parse(JSON.stringify(fjdata))
        let yysrArr = [
            {value:150000,label:"一级一等"},
            {value:80000,label:"一级二等"},
            {value:50000,label:"一级三等"},
            {value:30000,label:"二级一等"},
            {value:15000,label:"二级二等"},
            {value:10000,label:"二级三等"},
            {value:8000,label:"三级一等"},
            {value:6000,label:"三级二等"},
            {value:4000,label:"三级三等"},
            {value:2000,label:"四级一等"},
            {value:1000,label:"四级二等"},
            {value:500,label:"四级三等"},
            {value:300,label:"五级一等"},
            {value:200,label:"五级二等"},
            {value:100,label:"五级三等"},
            {value:50,label:"六级一等"},
            {value:30,label:"六级二等"},
            {value:12,label:"六级三等"},
            {value:6,label:"七级一等"},
            {value:1,label:"七级二等"},
            {value:0,label:"七级三等"},
            {value:-1,label:"八级一等"},
            {value:-6,label:"八级二等"},
            {value:-12,label:"八级三等"},
            {value:-30,label:"九级一等"},
            {value:-50,label:"九级二等"},
            {value:-100,label:"九级三等"},
            {value:-200,label:"十级一等"},
            {value:-300,label:"十级二等"},
            {value:-500,label:"十级三等"},
            {value:-1000,label:"十一级一等"},
            {value:-2000,label:"十一级二等"},
            {value:-4000,label:"十一级三等"},
            {value:-6000,label:"十二级一等"},
            {value:-8000,label:"十二级二等"},
            {value:-10000,label:"十二级三等"},
            {value:-15000,label:"十三级一等"},
            {value:-30000,label:"十三级二等"},
            {value:-50000,label:"十三级三等"},
            {value:-80000,label:"十四级一等"},
            {value:-15000,label:"十四级二等"},
            {value:-150000,label:"十四级三等"},
        ]
        if(e=='2'){
        // 按距离从近到远
            this.searchList(fjPage,'asc');
        }else if(e=='3'){
            // 按距离从远到近
            this.searchList(fjPage,'desc');
        }else if(e=='4'){
        // 按推荐度从小到大
            let harr = [],narr = [],allArr = [];
            for(let i in newData){
                let item = newData[i]
                if(item.SCORES){
                    harr.push(item)
                }else{
                    narr.push(item)
                }
            }
            harr.sort((a,b)=>{
                return a.SCORES - b.SCORES
            })
            allArr = harr.concat(narr)
            this.setState({fjdata:allArr})
        }else if(e=='5'){
        // 按推荐度从大到小
            let harr = [],narr = [],allArr = [];
            for(let i in newData){
                let item = newData[i]
                if(item.SCORES){
                    harr.push(item)
                }else{
                    narr.push(item)
                }
            }
            harr.sort((a,b)=>{
                return b.SCORES - a.SCORES
            })
            allArr = harr.concat(narr)
            this.setState({fjdata:allArr})
        }else if(e=='6'){
        // 按营业收入从小到大
            let harr = [],narr = [],allArr = [];
            for(let i in newData){
                let item = newData[i]
                let val = yysrArr.find((v)=>{return item.VENDINCRANK == v.label})
                if(val){
                    item.VENDINCRANK_VALUE = val.value
                    harr.push(item)
                }else{
                    narr.push(item)
                }
            }
            harr.sort((a,b)=>{
                return a.VENDINCRANK_VALUE - b.VENDINCRANK_VALUE
            })
            allArr = harr.concat(narr)
            this.setState({fjata:allArr})
        }else if(e=='7'){
        // 按营业收入从大到小
            let harr = [],narr = [],allArr = [];
            for(let i in newData){
                let item = newData[i]
                let val = yysrArr.find((v)=>{return item.VENDINCRANK == v.label})
                if(val){
                    item.VENDINCRANK_VALUE = val.value
                    harr.push(item)
                }else{
                    narr.push(item)
                }
            }
            harr.sort((a,b)=>{
                return b.VENDINCRANK_VALUE - a.VENDINCRANK_VALUE
            })
            allArr = harr.concat(narr)
            this.setState({fjdata:allArr})
        }else if(e=='8'){
        // 按资产总额从小到大
            let harr = [],narr = [],allArr = [];
            for(let i in newData){
                let item = newData[i]
                if(item.ASSGRO){
                    harr.push(item)
                }else{
                    narr.push(item)
                }
            }

            for(let i in harr){
                let item = harr[i]
                if(item.ASSGRO.includes('以内')){
                    item.ASSGRO_VALUE = 10*10000
                }else if(item.ASSGRO.includes('至')){
                    let arr = item.ASSGRO.split('至')
                    var num1 = arr[0].replace(/[^\d]/g, " ");
                    var num2 = arr[1].replace(/[^\d]/g, " ");
                    if(arr[0].includes('万')){
                        num1 = num1*10000
                    }else if(arr[0].includes('亿')){
                        num1 = num1*100000000
                    }
                    if(arr[1].includes('万')){
                        num2 = num2*10000
                    }else if(arr[1].includes('亿')){
                        num2 = num2*100000000
                    }
                    if(num1>num2){
                        item.ASSGRO_VALUE = num1
                    }else{
                        item.ASSGRO_VALUE = num2
                    }
                }else if(item.ASSGRO.includes('以上')){
                    item.ASSGRO_VALUE = 1000000000
                }else if(item.ASSGRO.includes('零')){
                    item.ASSGRO_VALUE = 0
                }else{
                    item.ASSGRO_VALUE = 0
                }
            }

            harr.sort((a,b)=>{
                return a.ASSGRO_VALUE - b.ASSGRO_VALUE
            })
            allArr = harr.concat(narr)
            this.setState({fjdata:allArr})
        }else if(e=='9'){
        // 按资产总额从大到小
            let harr = [],narr = [],allArr = [];
            for(let i in newData){
                let item = newData[i]
                if(item.ASSGRO){
                    harr.push(item)
                }else{
                    narr.push(item)
                }
            }

            for(let i in harr){
                let item = harr[i]
                if(item.ASSGRO.includes('以内')){
                    item.ASSGRO_VALUE = 10*10000
                }else if(item.ASSGRO.includes('至')){
                    let arr = item.ASSGRO.split('至')
                    var num1 = arr[0].replace(/[^\d]/g, " ");
                    var num2 = arr[1].replace(/[^\d]/g, " ");
                    if(arr[0].includes('万')){
                        num1 = num1*10000
                    }else if(arr[0].includes('亿')){
                        num1 = num1*100000000
                    }
                    if(arr[1].includes('万')){
                        num2 = num2*10000
                    }else if(arr[1].includes('亿')){
                        num2 = num2*100000000
                    }
                    if(num1>num2){
                        item.ASSGRO_VALUE = num1
                    }else{
                        item.ASSGRO_VALUE = num2
                    }
                }else if(item.ASSGRO.includes('以上')){
                    item.ASSGRO_VALUE = 1000000000
                }else if(item.ASSGRO.includes('零')){
                    item.ASSGRO_VALUE = 0
                }else{
                    item.ASSGRO_VALUE = 0
                }
            }

            harr.sort((a,b)=>{
                return b.ASSGRO_VALUE - a.ASSGRO_VALUE
            })
            allArr = harr.concat(narr)
            this.setState({fjdata:allArr})
        }else{
            this.setState({fjdata:fjndata})
        }
    }

    routerTo(){
        this.props.history.push({
            pathname: '/home/searchTag',
          })
    }

    pageOnChange(page, pageSize){
        // this.setState({
        //     fjPage:page
        // },()=>{
            this.searchList(page)
        // })
    }

    render() 
    {
        const { filterTypeOptions, filterTypeData, filterTypeValue, tabs, tabType,
            tagTreeOption, tagTreeData, confirmValues, tagNodes,keyWordFilterTypeData, 
            keyWordFilterType, keyWordRanges, rangeData, searchKeyWords, confirmKeyWords, 
            keyWords, keyword,attributes, confirmConditions, conditions, keyWordRangeData,
            tableOptions, loading, total, data, page, columns, detailData, messageOptions, 
            filterDrawerOptions, drawerOptions, checkDataLength, confirmMapConditions, fjdata,fuzzyValue,fjloading,fjPage,
            fjtotal,
            mapConditions,enter,groupData,selectoptions,group,distance,distanceData,fuzzySearchData } = this.state;

            
        return (
            <div className="page search-tag-wrap page-overflow">
                <div className="page-content page-tag-content" style={{ background: 'none' }}>
                    <div className="content-top padding-bottom-16">
                        <div id="contentTagDetail" className="content-canvas content-top-tag content-top-tag2" style={{ height: "auto", display: "table"}} >
                            <div className="contentTagTitle">
                                <img src={TitleLeft} className='TitleLeft' style={{float:"left"}} />
                                <p style={{float:"left"}} >企业查询</p>
                            </div>
                            <div style={{ width: "100%", height: "70px", paddingTop: "20px" ,textAlign:"center"}}>
                                <AutoComplete
                                    style={{ width: '60%',marginRight:'10px' }}
                                    size='large'
                                    allowClear
                                    onSelect={(value)=>{this.fuzzyOnChange(value)}}
                                    onSearch={(value)=>{this.fuzzyOnSearch(value)}}
                                    placeholder="输入企业名称进行模糊搜索"
                                    >
                                    {
                                        fuzzySearchData.map((item)=>{
                                            return <Option key={item.entname} value={item.entname}>{item.entname}</Option>
                                        })
                                    }
                                </AutoComplete>
                                {/* <Select
                                    style={{ width: '60%' }}
                                    size='large'
                                    showSearch
                                    allowClear
                                    placeholder="输入企业名称进行模糊搜索"
                                    // optionFilterProp="children"
                                    onChange={(value)=>{this.fuzzyOnChange(value)}}
                                    onSearch={(value)=>{this.fuzzyOnSearch(value)}}
                                    // filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                >
                                    {
                                        fuzzySearchData.map((item)=>{
                                            return <Option value={item.entname}>{item.entname}</Option>
                                        })
                                    }
                                </Select> */}
                                <Button size='large' onClick={()=>{
                                    this.search(1)
                                }}>搜索</Button>
                                <Button size='large' type="primary" style={{marginLeft:'10px'}} onClick={()=>{
                                    this.routerTo()
                                }}>高级搜索</Button>
                            </div>
                        </div>
                    </div>
                    {
                        fuzzyValue==''? 
                        <div>
                            <div className="content-title Addroles2" style={{ height: "60px",paddingRight:"36px",background:"#fff"}}>
                            <div className='search-left'>
                                <div className="contentTagTitle" style={{border:'none'}}>
                                    <img src={TitleLeft} className='TitleLeft' style={{float:"left",marginTop:'17px'}} />
                                    <p style={{float:"left",fontSize:'16px'}} >附近优企</p>
                                </div>
                            </div>
                            <div className="monitoring ">
                                <div>
                                    <Select defaultValue="2" allowClear style={{ width: '180px' }} onChange={(e)=>this.exportSelect(e)}>
                                        <Option key="2" value="2">按距离从近到远</Option>
                                        {/* <Option key="3" value="3">按距离从远到近</Option>
                                        <Option key="4" value="4">按推荐度从小到大</Option> */}
                                        <Option key="5" value="5">按推荐度从大到小</Option>
                                        {/* <Option key="6" value="6">按营业收入从小到大</Option> */}
                                        <Option key="7" value="7">按营业收入从大到小</Option>
                                        {/* <Option key="8" value="8">按资产总额从小到大</Option> */}
                                        <Option key="9" value="9">按资产总额从大到小</Option>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="content-bottom">
                            <div id="contentTagReport" className="content-report content-canvas content-bottom-frame">
                                <div className="content-report" style={{ minHeight: 50 }}>
                                {fjloading?
                                        <div style={{textAlign:'center',paddingTop:'100px',paddingBottom:'100px'}}><Spin /></div>:
                                        <div style={{paddingBottom:'20px'}}>

                                            <table className='re_search_detail_table'>
                                                <thead>
                                                    <tr>
                                                        <td className='detailtitle' style={{width:"10%"}}>序号</td>
                                                        <td className='detailtitle' style={{width:"10%"}}>企业名称</td>
                                                        <td className='detailtitle taking' style={{width:"10%"}}>
                                                            推荐度 <span className='desc_icon' style={{marginTop:0,float:'none'}}>?</span>
                                                            <div className='desc_wrap'>
                                                                <p style={{width:'100%'}}>推荐度用于表征基于企业自身所处行业、市场地位、成长能力、注册资本、实缴资本、就业人数数据所体现出的企业综合评价存款潜力（60分以下不推荐；61-80分较推荐；81-100分极为推荐）</p>
                                                            </div>
                                                        </td>
                                                        <td className='detailtitle taking' style={{width:"10%"}}>
                                                            营业收入 <span className='desc_icon' style={{marginTop:0,float:'none'}}>?</span>
                                                            <div className='desc_wrap'>
                                                                <p><span>&gt;=150000</span><span>一级一等</span></p>
                                                                <p><span>[80000,150000)</span><span>一级二等</span></p>
                                                                <p><span>[50000,80000)</span><span>一级三等</span></p>
                                                                <p><span>[30000,50000)</span><span>二级一等</span></p>
                                                                <p><span>[15000,30000)</span><span>二级二等</span></p>
                                                                <p><span>[10000,15000)</span><span>二级三等</span></p>
                                                                <p><span>[8000,10000)</span><span>三级一等</span></p>
                                                                <p><span>[6000,8000)</span><span>三级二等</span></p>
                                                                <p><span>[4000,6000)</span><span>三级三等</span></p>
                                                                <p><span>[2000,4000)</span><span>四级一等</span></p>
                                                                <p><span>[1000,2000)</span><span>四级二等</span></p>
                                                                <p><span>[500,1000)</span><span>四级三等</span></p>
                                                                <p><span>[300,500)</span><span>五级一等</span></p>
                                                                <p><span>[200,300)</span><span>五级二等</span></p>
                                                                <p><span>[100,200)</span><span>五级三等</span></p>
                                                                <p><span>[50,100)</span><span>六级一等</span></p>
                                                                <p><span>[30,50)</span><span>六级二等</span></p>
                                                                <p><span>[12,30)</span><span>六级三等</span></p>
                                                                <p><span>[6,12)</span><span>七级一等</span></p>
                                                                <p><span>[1,6)</span><span>七级二等</span></p>
                                                                <p><span>[0,1)</span><span>七级三等</span></p>
                                                                <p><span>[-1,0)</span><span>八级一等</span></p>
                                                                <p><span>[-6,-1)</span><span>八级二等</span></p>
                                                                <p><span>[-12,-6)</span><span>八级三等</span></p>
                                                                <p><span>[-30,-12)</span><span>九级一等</span></p>
                                                                <p><span>[-50,-30)</span><span>九级二等</span></p>
                                                                <p><span>[-100,-50)</span><span>九级三等</span></p>
                                                                <p><span>[-200,-100)</span><span>十级一等</span></p>
                                                                <p><span>[-300,-200)</span><span>十级二等</span></p>
                                                                <p><span>[-500,-300)</span><span>十级三等</span></p>
                                                                <p><span>[-1000,-500)</span><span>十一级一等</span></p>
                                                                <p><span>[-2000,-1000)</span><span>十一级二等</span></p>
                                                                <p><span>[-4000,-2000)</span><span>十一级三等</span></p>
                                                                <p><span>[-6000,-4000)</span><span>十二级一等</span></p>
                                                                <p><span>[-8000,-6000)</span><span>十二级二等</span></p>
                                                                <p><span>[-10000,-8000)</span><span>十二级三等</span></p>
                                                                <p><span>[-15000,-10000)</span><span>十三级一等</span></p>
                                                                <p><span>[-30000,-15000)</span><span>十三级二等</span></p>
                                                                <p><span>[-50000,-30000)</span><span>十三级三等</span></p>
                                                                <p><span>[-80000,-50000)</span><span>十四级一等</span></p>
                                                                <p><span>[-15000,-80000)</span><span>十四级二等</span></p>
                                                                <p><span>&lt;150000</span><span>十四级三等</span></p>
                                                            </div>
                                                        </td>
                                                        <td className='detailtitle' style={{width:"10%"}}>资产总额</td>
                                                        <td className='detailtitle' style={{width:"10%"}}>行业类型</td>
                                                        <td className='detailtitle' style={{width:"10%"}}>经营地址</td>
                                                        <td className='detailtitle' style={{width:"10%"}}>注册时间</td>
                                                        <td className='detailtitle' style={{width:"10%"}}>经营状态</td>
                                                        <td className='detailtitle' style={{width:"10%"}}>操作</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {fjdata.length>0?
                                                        fjdata.map((item,index)=>{
                                                            return <tr>
                                                                    <td >{index+1}</td>
                                                                    <td style={{color:'#1890ff',cursor: 'pointer'}} onClick={()=>{this.tableOnEvent('entityDetail',JSON.stringify(item),item.ENTNAME)}}>{item.ENTNAME}</td>
                                                                    <td style={{color:item.SCORES?
                                                                            parseInt(item.SCORES)<=516?'red':
                                                                            parseInt(item.SCORES)>=517&&parseInt(item.SCORES)<=688?'#f38e2d':
                                                                            parseInt(item.SCORES)>=689?'green':'red'
                                                                            :'red'}}>
                                                                        {
                                                                        item.SCORES?
                                                                            parseInt(item.SCORES)<=516?'不推荐':
                                                                            parseInt(item.SCORES)>=517&&parseInt(item.SCORES)<=688?'较为推荐':
                                                                            parseInt(item.SCORES)>=689?'极为推荐':'不推荐'
                                                                            :'不推荐'
                                                                        }
                                                                    </td>
                                                                    <td >{item.VENDINCRANK?item.VENDINCRANK:'-'}</td>
                                                                    <td >{item.ASSGRO?item.ASSGRO:'-'}</td>
                                                                    <td >{item.INDUSTRYPHY?item.INDUSTRYPHY:'-'}</td>
                                                                    <td >{item.OPLOC&&item.OPLOC.length>0?item.OPLOC[0].addr:'-'}</td>
                                                                    <td >{item.ESTDATE?item.ESTDATE:'-'}</td>
                                                                    <td >{item.REGSTATE?item.REGSTATE:'-'}</td>
                                                                    <td >
                                                                        {item.MONITOR?
                                                                        <Button size="small" onClick={()=>{this.removeMonitor(JSON.stringify(item))}}>取消监控</Button>:
                                                                        <Button size="small" onClick={()=>{this.addMonitor(JSON.stringify(item))}}>添加监控</Button>
                                                                        }
                                                                        <Button size="small" type="primary" style={{marginTop:'10px'}} onClick={()=>{this.addCRM(JSON.stringify(item))}}>添加CRM</Button>
                                                                    </td>
                                                                </tr>
                                                        }):<tr>
                                                            <td colSpan="10">
                                                                <Empty />
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
    
                                            {/* <Pagination defaultCurrent={fjPage} total={fjtotal}  /> */}
                                            <Pagination style={{textAlign:'right',marginTop:'20px'}} simple defaultPageSize={25} defaultCurrent={fjPage} total={fjtotal} onChange={(page,size)=>this.pageOnChange(page,size)} />
                                        </div>
                                }
                                    {/* <WidgetPageTable onRef={(ref) => { this.WidgetPageTableRef = ref }} options={tableOptions} columns={columns} data={data} total={total} loading={loading}
                                        notify={this.tableOnEvent} onCheck={this.tableOnCheck} pageTurning={this.pageTurning} page={page} /> */}
                                        
                                </div>
                            </div>
                        </div>
                        </div>
                        :
                        <div>
                            <div className="content-title Addroles2" style={{ height: "60px",paddingRight:"36px",background:"#fff"}}>
                                <div className='search-left'>
                                    <p>为您找到 <span className='num'>{total}</span> 家企业</p>
                                    {/* <div>
                                    <select onChange={(e)=>this.exportSelect(e)}>
                                        <option>批量选择</option>
                                        <option key="2" value="2">选择前20条记录</option>
                                        <option key="3" value="3">选择前50条记录</option>
                                        <option key="4" value="4">选择前100条记录</option>
                                        <option key="5" value="5">选择全部记录</option>
                                    </select>
                                    </div> */}
                                </div>
                                <div className="monitoring ">
                                    <span className="selectedB">已选择 <span className="selectedBM">{checkDataLength}</span></span>
                                    <button className="export-button"  onClick={this.export}><img className="export" src={require("../img/exportData.svg")}/>导出数据</button>
                                    {/* <div style={{marginRight:'20px',float:'left'}}>
                                        <span style={{ float: "left", fontSize:"14px", color:'#333' }}>{"推荐度排序 "}&nbsp;&nbsp;</span>
                                        <WidgetSelect options={selectoptions} data={groupData} className="SelectS"  onSelect={(value)=>this.changeFilterType(value,'group')} defaultValue={group} ></WidgetSelect>
                                    </div>
                                    <div style={{marginRight:'20px',float:'left'}}>
                                        <span style={{ float: "left", fontSize:"14px", color:'#333' }}>{"距离排序"}&nbsp;&nbsp;</span>
                                        <WidgetSelect options={selectoptions} data={distanceData} className="SelectS"  onSelect={(value)=>this.changeFilterType(value,'distance')} defaultValue={distance} ></WidgetSelect>
                                    </div> */}
                                    <div className="addButton click" onClick={() => { this.addMonitors() }}>
                                        <span>添加监控</span>
                                    </div>
                                    <div className="closeCRMButton" onClick={() => { this.addCRMs(2) }}>
                                        <span>添加CRM</span>
                                    </div>
                                    {/* <div className="remove-button horizontal-middle click" onClick={()=>{this.delete(3)}}>
                                            <span >删除种子用户</span>
                                        </div> */}
                                </div>
                            </div>
                            {/* 企业列表 */}
                            <div className="content-bottom">
                                <div id="contentTagReport" className="content-report content-canvas content-bottom-frame">
                                    {/* <div className="content-title" style={{ padding: '0 16px' }}>
                                        <div className="img">
                                            <img src={require("../img/profiles/bt.png")} alt=""></img>
                                        </div>
                                        <div className="font">
                                            <span>查询结果列表</span>
                                        </div>
                                    </div> */}
                                    <div className="content-report" style={{ minHeight: 160 }}>
                                        <WidgetPageTable onRef={(ref) => { this.WidgetPageTableRef = ref }} options={tableOptions} columns={columns} data={data} total={total} loading={loading}
                                            notify={this.tableOnEvent} onCheck={this.tableOnCheck} pageTurning={this.pageTurning} page={page} />
                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* 企业列表 */}

                </div>

                {/* 企业详情 */}
                <div className="scroll">
                    <WidgetDrawer options={drawerOptions} onRef={this.drawerRef} >
                        <div className="frame-body">
                            <EntityDetail data={detailData} search={this.search}></EntityDetail>
                        </div>
                    </WidgetDrawer>
                </div>

                {/* 操作信息提示 */}
                <WidgetMessage options={messageOptions} onRef={this.setMessageRef} />
            </div>
               
        )
    }
}

export default NearbyEnt;

// 条件展示组件
const BuildCondition = (props) => {

    let { parent, conditions, values, keywords, ranges, attributes, keyWordFilterType, mapConditions} = props;
    
    return (
        <div>
            {/* 条件查询 */}
            <ConditionQuery parent={parent} attributes={attributes} conditions={conditions}></ConditionQuery>

            {/* 标签查询 */}
            <ContentTag parent={parent} values={values}></ContentTag>

            {/* 智能检索 */}
            <ContentKeyword parent={parent} keywords={keywords} ranges={ranges} keyWordFilterType={keyWordFilterType} ></ContentKeyword>

            {/* POI(地图)查询 */}
            <MapCondition parent={parent} mapConditions={mapConditions} ></MapCondition>
        </div>
    )
}

const ConditionQuery = (props) => {

    let { conditions, attributes, parent } = props;
    if (conditions === undefined || Object.keys(conditions).length === 0) return null;

    return (
        <div className="flowRoot" style={{}}>
            <div className="search-title">
                <div style={{width:"5%",float:"left",marginTop:"10px"}}>{"条件筛选"}</div>
                <div className="flowRoot" style={{width:"95%",float:"left",marginTop:"10px"}}>
                    <BuildConditionFilter conditions={conditions} attributes={attributes} parent={parent} />
                </div>
            </div>
        </div>
    )
}

const BuildConditionFilter = (props) => {

    let { conditions, attributes, parent } = props, flag = true;

    return (
        attributes.map((item, index) => {

            let key = item.name;

            if (item.type === "DIMENSION") {
                key = item.content.code;
            }

            if (conditions[key] !== undefined) {
                if (flag) {
                    flag = false;

                    return (
                        <div className="tag-conditions" key={index} onClick={(e) => { parent.openFilterDrawer(e) }} >
                            <AttributeCondition attribute={item} condition={conditions[key]} parent={parent}></AttributeCondition>
                        </div>
                    )
                }
                else {
                    return (
                        <div key={index}>
                            <div className="tag-conditions" key={index} onClick={(e) => { parent.openFilterDrawer(e) }}>
                                <AttributeCondition attribute={item} condition={conditions[key]} parent={parent}></AttributeCondition>
                            </div>
                        </div>
                    )
                }
            }

        })
    )
}

const AttributeCondition = (props) => {

    let { attribute, condition, parent } = props;

    if (attribute.type === "STRING")
     {
        return (
            <div className="value-div-1-p">
                <div className="value-div-1">
                    {attribute.title} : {condition}
                </div>
                <span className="value-div-1-b"
                    onClick={(e) => { parent.deleteAttributeCondition(e, attribute) }} >
                    {"×"}
                </span>
            </div>
        );
    }
    else if (attribute.type === "DATE") 
    {
        return (
            <div className="value-div-1-p">
                <div className="value-div-1">
                    {attribute.title}:&nbsp;&nbsp;{condition.start} {"至"} {condition.end}
                </div>
                <span className="value-div-1-b"
                    onClick={(e) => { parent.deleteAttributeCondition(e, attribute) }} >
                    {"×"}
                </span>
            </div>
        );
    }
    else if (attribute.type === "NUMBER" || attribute.type === "INTEGER") {
        return (
            <div className="value-div-1-p">
                <div className="value-div-1">
                    {attribute.title}:&nbsp;&nbsp;{condition.start ? condition.start : 0} {" - "} {condition.end ? condition.end : "-"}
                </div>
                <span className="value-div-1-b"
                    onClick={(e) => { parent.deleteAttributeCondition(e, attribute) }} >
                    {"×"}
                </span>
            </div>
        );
    }
    else if (attribute.type === "NOMINAL") 
    {
        let name = condition;

        for (let contentItem of attribute.content) {
            if (contentItem.value === name) {
                name = contentItem.name;
            }
        }

        return (
            <div className="value-div-1-p">
                <div className="value-div-1">
                    {attribute.title}:{name}
                </div>
                <span className="value-div-1-b"
                    onClick={(e) => { parent.deleteAttributeCondition(e, attribute) }} >
                    {"×"}
                </span>
            </div>
        );
    }
    else if (attribute.type==="DIMENSION") 
    {
        let name = "", isFirst = true;

        if ( attribute.index==="MULTIPLE" ) 
        {
            for ( let key in condition ) 
            {
                for (let filterItem of condition[key])
                {
                    if (isFirst) 
                    {
                        name = filterItem.label;
                        isFirst = false;
                    }
                    else 
                    {
                        name += "," + filterItem.label;
                    }
                }
            }
        }
        else
        {
            for (let key in condition) 
            {
                name = condition[key].label;
            }
        }

        return (
            <div className="value-div-1-p">
                <div className="value-div-1">
                    {attribute.title}:{name}
                </div>
                <span className="value-div-1-b"
                    onClick={(e) => { parent.deleteAttributeCondition(e, attribute) }} >
                    {"×"}
                </span>
            </div>
        );
    }
    else 
    {
        return "";
    }
}

const ContentKeyword = (props) => {

    let { parent, keywords, ranges, keyWordFilterType } = props;

    let keyWordFilterTypeItem = parent.findFilterType(keyWordFilterType);

    if (keywords === undefined || keywords.length === 0 || ranges === undefined || ranges.length === 0) return null;
    
    return (
        <div className="flowRoot">
            
            <div className="search-title">
                <div style={{width:"5%",float:"left"}}>智能检索</div>
                
                <div style={{width:"95%",float:"left"}}>
                    <div style={{fontSize:"12px",fontWeight:"bold"}}>检索词（<span>{keyWordFilterTypeItem.label}</span>）：</div>
                    <div className="flowRoot">
                        {
                            keywords.map((item, index) => {
                                return (
                                    <div className="value-div-1-p" style={{marginTop:"10px"}} onClick={(e) => { parent.openFilterDrawer(e) }}>
                                        <div className="value-div-1">
                                            {item}
                                        </div>
                                        <span className="value-div-1-b"
                                            onClick={(e) => { parent.removeTerm(item, e) }} >
                                            {"×"}
                                        </span>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <div className="range-title">
                    <div style={{width:"5%",float:"left",marginTop:"10px"}}>查找范围 ：</div>
                    <div className="flowRoot" style={{width:"95%",float:"left"}}>
                        {
                            ranges.map((item, index) => {
                                return (
                                    <div className="value-div-1-p" style={{marginTop:"10px"}} onClick={(e) => { parent.openFilterDrawer(e) }}>
                                        <div className="value-div-1">
                                            {item.title}
                                        </div>
                                        <span className="value-div-1-b"
                                            onClick={(e) => { parent.deleteKeywordRange(item, e) }}>
                                            {"×"}
                                        </span>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

const Keyword = (props) => {

    let { keyword, parent } = props;

    if (keyword === undefined || keyword.length === 0) return null;

    return (
        // <div className="font-title">{this.props.enter}</div>
        keyword.map((item, index) =>{
            return(
                <div className={item.isClick ?"intellect-search-div4 keyword div-4-click" : "intellect-search-div4 keyword"} 
                     onClick={() =>{ parent.addKeyword(item) }} key={index}>
                    
                    <div className="font">{ item.association } +</div>
                </div>
            )
        })
    )
}

const Keywords = (props) => {

    let { keywords, parent } = props;

    if (keywords === undefined || keywords.length === 0) return null;

    return (
        keywords.map((item, index) => {
            return (
                <div className="intellect-search-div4" key={index}>
                    <div className="font">{item}</div>
                    <span className="value-div-1-b"
                        onClick={(e) => { parent.deleteKeyword(item) }} >
                        {"×"}
                    </span>
                </div>
            )
        })
    )

}

const ContentTag = (props) => {

    let { parent, values } = props;

    if (values === undefined || values === null || values.length === 0) {
        return null;
    }

    return (
        <div className="flowRoot">
            <div className="search-title">
                <div style={{width:"5%",float:"left", marginTop:"10px"}}>标签查询</div>
                <div style={{width:"95%",float:"left", marginTop:"15px"}}><TagConditions datas={values} parent={parent}></TagConditions></div>
                
            </div>
            
        </div>
    )
}

const TagConditions = (props) => {

    let { datas, parent } = props, flag = true;

    if (datas === undefined || datas.lenght === 0) return null;

    return (
        datas.map((item, index) => {

            if (flag) {
                flag = false;
                return (
                        <TagCondition data={item} parent={parent}></TagCondition>
                )
            }
            else {
                return (
                        <TagCondition data={item} parent={parent}></TagCondition>
                )
            }

        })
    )
};

const TagCondition = (props) => {

    let { data, parent } = props;
    let flag = true;

    return (
        data.map((item, index) => {

            if (flag) {
                flag = false;

                return (
                    <div key={index} className="value-div-1-p" style = {{marginBottom:"10px"}} onClick={(e) => { parent.openFilterDrawer(e) }}>
                        <div className="value-div-1">
                            {item.parentCatalog.label} : {item.label}
                        </div>
                        <span className="value-div-1-b"
                            onClick={(e) => { parent.deleteTagConditions(item, e) }} >
                            {"×"}
                        </span>
                    </div>
                )
            }
            else {
                return (
                    <div key={index} className="value-div-1-p" style = {{marginBottom:"10px"}} onClick={(e) => { parent.openFilterDrawer(e) }}>
                        <div className="value-div-1">
                            {item.parentCatalog.label} : {item.label}
                        </div>
                        <span className="value-div-1-b"
                            onClick={(e) => { parent.deleteTagConditions(item, e) }} >
                            {"×"}
                        </span>
                    </div>
                )
            }
        })
    )
};


const MapCondition = (props) => {
    
    let { parent, mapConditions} = props;

    if( mapConditions===undefined || mapConditions===null || Object.keys(mapConditions).length===0  ){
        return null;
    }

    return(
        <div className="flowRoot">
            <div className="search-title">
                <div style={{width:"5%",float:"left",marginTop:"5px"}}>地图查询</div>
                <div style={{width:"95%",float:"left",marginTop:"10px"}}><TagMapCondition mapConditions={mapConditions} parent={parent} /></div>
            </div>
        </div>
    )
}

const TagMapCondition = (props)=> {

    let { parent, mapConditions} = props;

    if( mapConditions.hasOwnProperty("mapType") )
    {
        if( mapConditions.hasOwnProperty("D150001") )
        {
            return (
                <div>
                    <MapPOICondition parent={parent} mapConditions={mapConditions} />
                    <MapPOIDimension parent={parent} condition={mapConditions["D150001"]} />
                </div>
            )
        }
        else
        {
            return (
                <div>
                    <MapPOICondition parent={parent} mapConditions={mapConditions} />
                </div>
            )
        }
    }
    else
    {
        if( mapConditions.hasOwnProperty("D150001") )
        {
            return <MapPOIDimension parent={parent} condition={mapConditions["D150001"]} />
        }
        else
        {
            return "";
        }
    }
}

const MapPOIDimension = (props)=> {

    let { parent, condition} = props;

    if( condition!==undefined )
    {
        let content = '', isFirst = true;

        for ( let key in condition ) 
        {
            for (let filterItem of condition[key])
            {
                if (isFirst) 
                {
                    content = filterItem.label;
                    isFirst = false;
                }
                else 
                {
                    content += "," + filterItem.label;
                }
            }
        }

        return ( 
            <div className="value-div-1-p">
                <div className="value-div-1">
                    {content}
                </div>
                <span className="value-div-1-b" onClick={()=>{parent.deleteMapPOIConditionition("D150001")}}>
                    {"×"}
                </span>
            </div>
        )
    }
    else
    {
        return "";
    }
}

const MapPOICondition = (props)=> {

    let { parent, mapConditions} = props;

    switch( mapConditions.mapType )
    {
        case "range" : 
        {
            if( mapConditions.circleCenter!==undefined && mapConditions.circleRadius!==undefined )
            {
                let circleCenter = mapConditions.circleCenter, circleRadius = mapConditions.circleRadius;

                return (
                    <div onClick={(e) => { parent.openFilterDrawer(e) }}>
                        <div key={circleCenter.value} className="value-div-1-p">
                            <div className="value-div-1">
                                {circleCenter.label}
                            </div>
                            <span className="value-div-1-b" onClick={(e)=>{parent.deleteMapPOICondition("range",e)}}>
                                {"×"}
                            </span>
                        </div>
                        <div key={circleRadius.value} className="value-div-1-p">
                            <div className="value-div-1">
                                {circleRadius.label}
                            </div>
                            <span className="value-div-1-b" onClick={(e)=>{parent.deleteMapPOICondition("range",e)}}>
                                {"×"}
                            </span>
                        </div>
                    </div>
                )
            }
            else
            {
                return "";
            }
        }
        case "circle" : 
        {
            if( mapConditions.center!==undefined && mapConditions.center!==null )
            {
                return ( 
                    <div className="value-div-1-p" onClick={() => { parent.openFilterDrawer() }}>
                        <div className="value-div-1">
                            {"圆形范围内"}
                        </div>
                        <span className="value-div-1-b" onClick={(e)=>{parent.deleteMapPOICondition("circle",e)}}>
                            {"×"}
                        </span>
                    </div>
                );
            }
            else
            {
                return "";
            }
            
        }
        case "rectangle" : 
        {
            if( mapConditions.points!==undefined && mapConditions.points!==null && mapConditions.points.length>0 )
            {
                return ( 
                    <div className="value-div-1-p">
                        <div className="value-div-1" onClick={() => { parent.openFilterDrawer() }}>
                            {"矩形范围内"}
                        </div>
                        <span className="value-div-1-b" onClick={(e)=>{parent.deleteMapPOICondition("rectangle",e)}}>
                            {"×"}
                        </span>
                    </div>
                );
            }
            else
            {
                return "";
            }
           
        }
        case "polygon" : 
        {
            if( mapConditions.points!==undefined && mapConditions.points!==null && mapConditions.points.length>0 )
            {
                return ( 
                    <div className="value-div-1-p" onClick={() => { parent.openFilterDrawer() }}>
                        <div className="value-div-1">
                            {"多边形范围内"}
                        </div>
                        <span className="value-div-1-b" onClick={(e)=>{parent.deleteMapPOICondition("polygon",e)}}>
                            {"×"}
                        </span>
                    </div>
                );
            }
            else 
            {
                return "";
            }
            
        }
    }

}